import classcat from "classcat";
import React from "react";

import ExternalPageDrawer from "@is/components/ExternalPageDrawer";
import Footer from "@is/components/Footer";
import SignUpStatusModal from "@is/components/SignUpStatusModal";
import StyleNotExistModal from "@is/features/Activities/StyleNotExistModal";
import HTWIWidget from "@is/features/ContentView/HTWIWidget";
import PrimaryAttributeDrawer from "@is/features/PrimaryAttributeDrawer";
import SettingsDrawer from "@is/features/SettingsDrawer";
import { HTWIContentWidget } from "@is/types";

import css from "./EntryView.module.css";
import useManageEntryView from "./hooks/useManageEntryView";

const EntryView = () => {
  const {
    t,
    handleOpenDrawer,
    handleCloseModal,
    navigateToContentView,
    showStyleNotExistModal,
    mediaElement,
    animateLeavingEntryView,
    showSettingsDrawer,
    handleSettingDrawerClose,
    signUpStatusModal,
    handleSignUpStatusModalClose,
    externalPageDrawer,
    handleExternalPageDrawerClose,
    widget,
    showWidgetOverlay,
    isWidgetTransitioning,
    ref,
  } = useManageEntryView();

  return (
    <div className={css.container} ref={ref}>
      <div
        data-testid="videoContainer"
        className={css.videoContainer}
        onClick={handleOpenDrawer}
      >
        {mediaElement}
      </div>
      {showWidgetOverlay && widget && (
        <div
          className={classcat([
            css.widgetOverlay,
            {
              [css.widgetOverlayVisible]:
                showWidgetOverlay && !isWidgetTransitioning,
              [css.widgetOverlayTransitioning]: isWidgetTransitioning,
            },
          ])}
        >
          <div className={css.widgetOverlayMain}>
            <div className={css.widgetOverlayHeader}>
              <div
                className={classcat([
                  "text-display-8xl",
                  css.widgetOverlayTitle,
                ])}
              >
                {t("discover your outfits here")}
              </div>
            </div>
            <div className={css.widgetOverlayContent}>
              <div className={css.widgetContainer}>
                <HTWIWidget
                  widget={widget as HTWIContentWidget}
                  containerRef={ref}
                  autoCarousel
                />
              </div>
            </div>
            <Footer
              isOpen
              showRestartSessionButton={false}
              showStoreFavoritesButton={false}
              enableStaffDashboard={false}
              inDrawer={false}
              borderTop
            />
          </div>
        </div>
      )}
      <PrimaryAttributeDrawer onNavigate={navigateToContentView} />
      <SettingsDrawer
        onClose={handleSettingDrawerClose}
        isOpen={showSettingsDrawer}
      />
      {showStyleNotExistModal && (
        <StyleNotExistModal onClose={handleCloseModal} />
      )}
      {signUpStatusModal.isOpen && (
        <SignUpStatusModal
          isOpen
          onClose={handleSignUpStatusModalClose}
          status={signUpStatusModal.status}
          errorMessage={signUpStatusModal.errorMessage}
        />
      )}
      {externalPageDrawer.isOpen && (
        <ExternalPageDrawer
          handleClose={handleExternalPageDrawerClose}
          src={externalPageDrawer.src}
        />
      )}
      {animateLeavingEntryView && (
        <>
          <div className={css.transitionView}></div>
          <div className={css.transitionViewTop}></div>
        </>
      )}
    </div>
  );
};

export default EntryView;
